module.exports = __webpack_public_path__ + "d57110c8ddf6ad94f2583c27d41b2a59.svg";